import React from 'react';

export default function Getdata(props) {
    return (
        <div>
        <div className="flexi">
                        <div className="cases"><h1>Cases:</h1>
                        <p>{props.conf}</p> 
                        </div>

                        <div className="recovered"><h1>Recovered:</h1>
                        <p>{props.recov}</p>
                        </div>

                        <div className="deaths"><h1>Deaths:</h1>
                        <p>{props.death}</p>
                        </div>

        </div>
        <div className="last">
        <p>Last updated at:{props.last}</p>
        </div>
        </div>
        
    )
}
